import React, { useState, useEffect, useRef, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import socket from './socket';

import Lobby from './components/Lobby/Lobby';
import GameInProgress from './components/GameInProgress/GameInProgress';
import ScreenLoadingComponent from './components/ScreenLoading/screenLoadingComponent';
import LoadingDoorComponent from './components/LoadingDoor/LoadingDoorComponent';
import Console from './components/Console/Console';
import Sandbox from './components/screens/sandbox/Sandbox';

import icoSoundOn from './assets/icoSound.png';
import icoSoundOff from './assets/icoMute.png';
import config from './utils/config';

const App = () => {

  const GameScreen = () => {

    const [manualMode, setManualMode] = useState(false);

    const [game_, setGame_] = useState(null);//proxy para evitar que se actualice el estado del juego de forma inmediata
    const [game, setGame] = useState(null);
    const [curtains, setCurtains] = useState(true);//las cortinas empiezan abiertas

    const [user, setUser] = useState(null);
    const [room, setRoom] = useState(null);

    const [error, setError] = useState(null);

    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const [isMuted, setIsMuted] = useState(false);

    const navigate = useNavigate();

    // Leer el estado guardado en localStorage al cargar el componente
    useEffect(() => {
      const savedMuted = localStorage.getItem("isMuted");
      const isMutedFromStorage = savedMuted === "true"; // convierte a booleano
      setIsMuted(isMutedFromStorage);

      // Aplicar estado de mute al cargar
      document.querySelectorAll("audio, video").forEach((el) => {
        el.muted = isMutedFromStorage;
      });
    }, []);

    // Función para alternar mute y guardar en storage
    const toggleMute = () => {
      setIsMuted((prev) => {
        const newMuted = !prev;

        // Aplicar nuevo estado a los elementos
        document.querySelectorAll("audio, video").forEach((el) => {
          el.muted = newMuted;
        });

        // Guardar nuevo estado
        localStorage.setItem("isMuted", String(newMuted));

        return newMuted;
      });
    };

    useEffect(() => {
      if (!isMobile) return; // Solo ejecuta en móviles

      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          window.location.reload(); // Recarga la página al volver al navegador
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    }, []);

    useEffect(() => {

      // Obtener parámetros de la URL
      const params = new URLSearchParams(window.location.search);
      const game_id = params.get("game");
      const module = params.get("module");
      const user = params.get("user");
      const playersToStart = parseInt(params.get("players")) || 4;
      const room = params.get("room");

      if (!game_id || !module || !user || !room) {
        setError("Faltan parámetros en la URL. Por favor, verifica la configuración.");
        return;
      }

      // Unirse al juego
      socket.emit("join_game", { game: game_id, user, module, playersToStart, room });

      setRoom(room);
      setUser(user);

      //estos eventos de los sockets NO SE CONECTAN bien con los 
      //eventos de react.
      const handleGameEvent = (data) => {
        setGame_(data);
      };

      const handleError = (data) => {
        console.error("Error:", data);
      }

      const handleGameAlreadyStarted = (data) => {
        if (data.user.id === user) {
          console.log("Redirigiendo al usuario:", data.message);
          alert("Redirigiendo al usuario: " + data.message);
          navigate("/"); // Redirigir a la página de landing
        }
      };

      socket.on("game_event", handleGameEvent);
      socket.on("error", handleError);
      socket.on("game_already_started", handleGameAlreadyStarted);


      return () => {
        socket.off("game_event", handleGameEvent);
        socket.off("error", handleError);
      };

    }, []);

    let timeout = useRef(null);
    useEffect(() => {

      if (manualMode) return;

      //si timeout existe, no hagas nada
      if (timeout.current) return;
      //si no hay informacion para el juego no hagas nada.
      if (!game_) return;

      //si game no existe o el nuevo estado de juego es diferente al estado actual
      if (!game || (game_.state !== game.state)) {
        setCurtains(false);
        timeout.current = setTimeout(() => {
          setGame(game_);
          setCurtains(true);
          timeout.current = null;
        }, 2000);
      }
      if (timeout.current == null) {
        setGame(game_);
        setCurtains(true);
      }

    }, [game_]);




    const StateButton = useCallback(({ s }) => {
      return (<button
        style={{ marginBottom: 10 }}
        onClick={() => {
          const newGame = { ...game };

          newGame.current_question = {
            "id": "aFDFIN2mqHVy0ZfC0oMN",
            "module": "1",
            "tiempoRespuesta": 15,
            "challenge": "Las BPM son normas que se aplican a lo largo de toda la cadena alimentaria y son vigiladas ",
            "respuestaCorrecta": "true",
            "feedbackFalsoVerdadero": "Son normas que se aplican a lo largo de toda la cadena alimentaria",
            "tipoDesafio": "soloTexto",
            "esFalsoVerdadero": "true",
            "company": "oSO5DqPaHtsP7moxREr0",
            "cardType": "desafioConocimiento",
            "room": "1"
          }

          if (s === "qualification") {
            newGame.current_question = {
              "id": "z30NTHGAS9QFDF9wWtjX",
              "module": "1",
              "tiempoRespuesta": 60,
              "challenge": "Graba un video de 30 segundos en el que expliques qué es BPM y por qué es importante en la industria alimentaria.",
              "apuntes": "Foto BPM",
              "tipoDesafio": "soloTexto",
              "tipoRespuesta": "audio",
              "company": "oSO5DqPaHtsP7moxREr0",
              "cardType": "desafioCreativo",
            }

            newGame.current_answer_qualification = {
              answer: "https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3",
            }
          }

          newGame.state = s;
          setGame(newGame);
        }}>{s}</button>)
    }, [])


    return (
      <div style={{ height: '100%', overflow: 'hidden' }}>
        <button className='btnSound' onClick={toggleMute}>
          <div>
            <img src={isMuted ? icoSoundOff : icoSoundOn}></img>
          </div>
        </button>

        {!game && <ScreenLoadingComponent />}

        {error && <div>Error: {error}</div>}

        {game && (game?.state === "standBy" ? (
          <Lobby user={user} game={game} socket={socket} />
        ) : (
          <GameInProgress user={user} game={game} socket={socket} room={room} />
        ))}

        <LoadingDoorComponent open={curtains} ></LoadingDoorComponent>


        {/** A development TOOL to test things...  */}
        <div style={{
          alignItems: "flex-start",
          flexDirection: "column",
          position: "fixed",
          bottom: 0,
          right: 0,
          padding: 10,
          background: "rgba(0,0,0,0.5)", color: "white",
          zIndex: 100,
          display: 'none'
        }}>
          {/**Check box for manual mode */}
          <div style={{ marginBottom: 10 }}>
            <input type="checkbox" id="manual" name="manual" onChange={(e) => {
              console.log("setManualMode: ", e.target.checked);
              setManualMode(e.target.checked)
            }} />
            Manual Mode
          </div>
          <StateButton s={"standBy"} />
          <StateButton s={"welcome"} />
          <StateButton s={"in_round"} />
          <StateButton s={"qualification"} />

        </div>
        {/** END OF development TOOL to test things...  */}
      </div>
    );
  }

  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<GameScreen />} />
          <Route path="/console" element={<Console />} />
          <Route path="/sandbox" element={<Sandbox />} />
        </Routes>
      </Router>
      <div hidden>
        {config.app_version}
      </div>
    </>
  );
};



export default App;
